import { Injectable } from '@angular/core';

@Injectable()
export class BreadcrumService {

  constructor() { }
  setUrl(name, value) {
    sessionStorage.setItem(name, value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/breadcrum.service.ts